import React from 'react'
import "../Layout/Layout.css"
import SavedChat from '../../component/SavedChats/SavedChats'
import MyContext from '../../Context/AppContext'
import { useNavigate } from 'react-router-dom'

const SavedChatsPage = () => {
    const { openDrawer, checkAuthStatus } = React.useContext(MyContext);
    const isLoggedIn = checkAuthStatus();
    const navigate = useNavigate();
    if(!isLoggedIn){
        navigate('/login')
    } 

    return (
        <>
            {
                isLoggedIn && <div className='maindiv_chatpage' >
                    <div className={openDrawer ? 'rightside_chatpage drawerOpen' : 'rightside_chatpage drawerClose'}>
                        <SavedChat openDrawer={openDrawer} />
                    </div>
                </div>
            }
        </>
    )
}

export default SavedChatsPage